import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";
import EmployeeLeaveCredits from "./index";
import ViewLeaveCredits from "./view";
import EditLeaveCredits from "./edit";
import { MODULE_EMP_LEAVE_CREDITS } from "variables/modules";

const employeeLeaveCreditsRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Employee Leave Credits",
		basePath: "employee-leave-credits",
		mainComponent: <EmployeeLeaveCredits />,
	    layout: "/console",	   
	    subTitle:"Employee Leave Credits",
	    viewComponent: <ViewLeaveCredits />,
	    createComponent: <EditLeaveCredits />,
	    editComponent: <EditLeaveCredits />,
		level:5,
		moduleId: MODULE_EMP_LEAVE_CREDITS,
	})
]

export default employeeLeaveCreditsRoutes;